import { createContext } from "react";

export const LocalidadesContext = createContext()
export const LocalidadesFormContext = createContext()
export const LocalidadesReportContext = createContext()